<template>
  <div class="quiz-main">
    <ButtonBack class="mb_s"/>
    <ButtonShuffle class="mb_m"/>
    <div class="table">
      <div class="table-header">
        <div class="table-header-number">
          クイズ番号
        </div>

        <div class="table-header-number">
          トランプ番号
        </div>

        <div class="table-header-suit">
          絵柄
        </div>

        <div class="table-header-name">
          場所名
        </div>

        <div class="table-header-options">
          緯度/経度/半径
        </div>
      </div>

      <div
        v-for="quiz in quizzes"
        :key="quiz.id"
        :quiz="quiz"
        class="table-cell"
        @click="editQuiz(quiz)"
        >

        <div class="table-cell-number">
          {{ quiz.get('number') }}
        </div>

        <div class="table-cell-card-number">
          {{ quiz.get('card').get('number') }}
        </div>

        <div class="table-cell-suit">
          {{ quiz.get('card').get('suit').get('ja') }}
        </div>

        <div class="table-cell-name">
          {{ quiz.get('name') }}
        </div>

        <div class="table-cell-options">
          {{ getQuizLocation(quiz, 'latitude') }} / {{ getQuizLocation(quiz, 'longitude') }} / {{ quiz.get('radius') || 0 }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'util'
import { mapState } from 'vuex'
import ButtonBack from '@/components/ButtonBack'
import ButtonShuffle from '@/components/Quiz/ButtonShuffle'

export default {
  components: {
    ButtonBack,
    ButtonShuffle
  },

  computed: {
    ...mapState('quiz', [
      'quizzes'
    ])
  },

  methods: {
    editQuiz: function (quiz) {
      this.$router.push({
        name: 'quizset-quiz-edit',
        params: {
          quizsetId: this.$route.params.id,
          id: quiz.id
        }
      })
    },
    getQuizLocation: function (quiz, key) {
      let location = quiz.get('location')
      if (location) {
        const rate = 10000
        return parseInt(location[key] * rate) / rate
      } else {
        return 0
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@mixin cell {
  $number_width: 8%;
  &-number {
    padding: 5px;
    width: $number_width;
  }

  &-card-number {
    padding: 5px;
    width: $number_width;
  }

  $suit_width: 10%;
  &-suit {
    padding: 5px;
    width: $suit_width;
  }

  $name_width: 50%;
  &-name {
    padding: 5px;
    width: $name_width;
  }

  &-options {
    padding: 5px;
    width: calc( 100% - #{$number_width * 2 + $suit_width + $name_width} );
  }
}

@import '@/styles/_table.scss';
@import '@/styles/_icon.scss';
</style>
